import { render, staticRenderFns } from "./templateConfirm.vue?vue&type=template&id=6bf45600&scoped=true"
import script from "./templateConfirm.vue?vue&type=script&lang=js"
export * from "./templateConfirm.vue?vue&type=script&lang=js"
import style0 from "./templateConfirm.vue?vue&type=style&index=0&id=6bf45600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf45600",
  null
  
)

export default component.exports